import { useGATracking } from "hooks/useGATracking";
import useScrollToTop from "hooks/useScrollToTop";
import { Redirect, Route, Switch } from "react-router-dom";

import config from "config";
import { routes } from "config/urls";
import CategorisationHelp from "pages/CategorisationHelp";
import Client from "pages/Client";
import Company from "pages/Company";
import Completed from "pages/Completed";
import Errors from "pages/Error";
import NoMatch from "pages/NoMatch";

function AppRouter() {
  useGATracking(config.GA_TRACKING_ID);
  useScrollToTop();

  return (
    <Switch>
      <Route path={routes.client.root} component={Client} />
      <Redirect
        path={routes.customIntro}
        to={{
          pathname: routes.client.root,
          search: window.location.search,
        }}
      />
      <Route path={routes.company.root} component={Company} />
      <Route path={routes.error} component={Errors} />
      <Route path={routes.completed} component={Completed} />
      <Route
        path={"/account-categorisation/help"}
        component={CategorisationHelp}
      />
      <Route path="*" component={NoMatch} />
    </Switch>
  );
}

export default AppRouter;
